import React, { FunctionComponent } from 'react';

import { get, keyBy } from 'lodash';

import { Sentiment } from 'common/comments2/Comments2.types';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldCategory.scss';

type SentimentClassname = 'negative' | 'neutral' | 'positive' | 'none';

const SENTIMENT: Record<Sentiment, SentimentClassname> = {
    [Sentiment.Negative]: 'negative',
    [Sentiment.Neutral]: 'neutral',
    [Sentiment.Positive]: 'positive',
    [Sentiment.None]: 'none',
};

export const TemplateFieldCategory: FunctionComponent<ContextProps> = ({ context }) => {
    const { review } = context;
    const { taxonomy_categories: categories, categoryLabels } = review!;
    const labelsById = keyBy(categoryLabels, 'id');

    if (!categoryLabels || !categories) {
        return null;
    }

    return (
        <div className="r4e-review-template-field-category">
            <div className="r4e-review-categories">
                {categories?.map((category: Record<string, Sentiment>) => {
                    const displayName = get(labelsById, `${category.uuid}.displayName`);

                    if (!displayName) {
                        return null;
                    }

                    return (
                        <div key={category.uuid} className={`r4e-review-category ${SENTIMENT[category.sentiment]}`}>
                            {displayName}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
